// src/Components/layout/Layout.jsx
import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useModal } from "../../context/ModalContext";
import TaskDetailsModal from "../TaskDetailsModal/TaskDetailsModal";
import BranchDetailsModal from "../BranchDetailsModal/BranchDetailsModal";
import "./Layout.css";

export default function Layout({ children }) {
  const { taskModalId, branchModalId, closeTaskModal, closeBranchModal } = useModal();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Prevent body scroll when sidebar is open on mobile
  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [sidebarOpen]);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className={`mq-app-shell ${sidebarOpen ? 'sidebar-open' : ''}`}>
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="mq-sidebar-overlay" onClick={closeSidebar} />
      )}

      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      <div className="mq-main">
        <Topbar onMenuClick={toggleSidebar} />
        <main className="mq-main-content">
          {children || <Outlet />}
        </main>
      </div>

      {/* Global Modals */}
      {taskModalId && (
        <TaskDetailsModal
          taskId={taskModalId}
          onClose={closeTaskModal}
        />
      )}
      {branchModalId && (
        <BranchDetailsModal
          branchId={branchModalId}
          onClose={closeBranchModal}
        />
      )}
    </div>
  );
}
